import { render, staticRenderFns } from "./TheGuestAccountBar.vue?vue&type=template&id=4fa53412&"
import script from "./TheGuestAccountBar.vue?vue&type=script&lang=js&"
export * from "./TheGuestAccountBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports